import React from 'react';
import { HeroSection } from './HeroSection';
import { LeadSection } from './LeadSection';
import { ProblemSection } from './ProblemSection';
import { FailedSolutionsSection } from './FailedSolutionsSection';
import { MechanismSection } from './MechanismSection';
import { RevealSection } from './RevealSection';
import { CTASection } from './CTASection';
import { Footer } from './Footer';
export function SalesPage() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <main className="min-h-screen bg-brand-bg text-brand-text selection:bg-brand-accent selection:text-white" data-id="element-146">
      <HeroSection data-id="element-147" />
      <LeadSection data-id="element-148" />
      <ProblemSection data-id="element-149" />
      <FailedSolutionsSection data-id="element-150" />
      <MechanismSection data-id="element-151" />
      <RevealSection data-id="element-152" />
      <CTASection data-id="element-153" />
      <Footer data-id="element-154" />

      {/* Floating CTA Button */}
      <button onClick={scrollToPricing} className="fixed bottom-6 right-6 z-40 px-6 py-3 bg-brand-accent hover:bg-brand-accent-hover text-white font-bold text-sm rounded-full shadow-[0_0_24px_rgba(230,126,34,0.5)] hover:shadow-[0_0_36px_rgba(230,126,34,0.7)] transition-all duration-300 whitespace-nowrap" aria-label="Go to pricing" data-id="element-155">
        Get It Now — $6.36
      </button>
    </main>;
}